<template>
  <div class="card" style="padding: 30px 0; height: 100%; overflow-y: scroll;">
    <div class="card-body" style="padding: 20px;">
      <div class="container-fluid">
        <table style="width: 100%;" id="kaltura_table"><tr>
          <td style="width: 66%;">
            <div style="width: 100%; display: inline-block; position: relative;">
              <video id="video" style="width: 100%;" :src="url" type="video/mp4" controls @playing="onVideoPlaying" @seeked="onVideoSeeked" @timeupdate="onTimeUpdate"></video>
            </div>
          </td>
          <td style="width: 33%;">
            <div style="font-size: 20pt; line-height: 1; background-color: #CCC;">
              <div>筆記<i class="clickable material-icons" style="float: right;" @click="isTakingNote = true">add_circle_outline</i></div>
            </div>
            <div style="width: 100%; display: inline-block; position: relative" v-bind:style="{'overflow': isTakingNote?'hidden':'scroll'}">
              <div style="margin-top: calc( 112.5% - 20pt ); ">
                <div id="note_list" style="position: absolute; top: 0; background-color: #EFEFEF; min-height: 100%; width: 100%;">
                  <NoteCell v-for="note in notes" :key="note.id" :note="note"/>
                </div>
                <div id="take_note" style="position: absolute; top: 0; background-color: #EFEFEF; width: 100%; padding: 0 15px; height: 100%; overflow-y: scroll;" v-show="isTakingNote">
                  <div>時間標記</div>
                  <div id="new_note_time" time="0">{{currentTime}}</div>
                  <div>筆記內容</div>
                  <textarea v-model="noteContent" rows="4" style="width: 100%;" id="new_note_content"></textarea>
                  <div style="width: 50%; display: inline-block; float: left; text-align: center;">
                    <button @click="post_note">發布</button>
                  </div>
                  <div style="width: 50%; display: inline-block; float: left; text-align: center;">
                    <button style="" @click="cancel_note_taking">取消</button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr></table>
        <div class="row">
          <!--   waiting table for course-user to edit the profile open to course. -->
          <div class="col-md-12">
            <h3 id="video_title">{{name}}</h3>
            <div id="video_description">{{description}}</div>
          </div>
          <div class="col-md-12">
            <div class="mdl-textfield mdl-js-textfield" style="width: 100%;">
              <md-field>
                <md-textarea v-model="commentMessage" type="text" id="comment_textarea" name="description" rows='4' placeholder="在此留言..."></md-textarea>
              </md-field>
            </div>
            <div style="text-align: right;">
              <md-button :md-ripple="true" class="md-raised">取消</md-button>
              <md-button :md-ripple="true" class="md-raised md-accent" style="margin-left: 10px;" id="comment_post_btn" :disabled="commentMessage.length === 0" @click="post_comment">發布</md-button>
            </div>
          </div>
          <div v-show="comments.length" class="col-md-12" id="discussion_div">
            <div id="discussion_list">
              <!-- <pre><?php //var_dump($replies); ?></pre> -->
              <CommentCell v-for="comment in comments" :key="comment.id" :comment="comment"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="text/css" scoped>
  #discussion_list p{
    margin-bottom: 0;
  }
  .discussion_cell, .reply_cell{
    margin-bottom: 16px;
  }
  .discussion_cell:last-child, .reply_cell:last-child{
    margin-bottom: 0;
  }
  .reply_cell:first-child{
    margin-top: 16px;
  }
  .reply_to{
    background-color: #EEE;
    margin-right: 10px;
  }
  .discussion_cell .comment_datetime{
    margin: 0 10px;
  }
</style>
<script>
import NoteCell from '@/components/Video/NoteCell'
import CommentCell from '@/components/Video/CommentCell'

// import $ from 'jquery'
let timeToString = function (currentTime) {
  let hour = ('00' + parseInt(currentTime / 3600)).substr(-2)
  let minute = ('00' + parseInt(currentTime % 3600 / 60)).substr(-2)
  let second = ('00' + parseInt(currentTime % 60)).substr(-2)
  return `${hour}:${minute}:${second}`
}
export default {
  components: {
    NoteCell,
    CommentCell
  },
  props: {
    courseId: Number,
    weekId: Number,
    id: Number
  },
  data () {
    return {
      note: null,
      videoId: -1,
      name: '',
      description: '',
      url: '',
      notes: [], // {id, label, time, message, timeString}
      noteContent: '',
      isTakingNote: false,
      currentTime: '00:00:00',
      commentMessage: '',
      comments: []
    }
  },
  methods: {
    post_note: function () {
      console.log(this.note)
      if (this.note !== null) {
        this.edit_note()
        return
      }
      let content = this.noteContent
      let video = document.getElementById('video')
      let time = video.currentTime
      let fd = new FormData()
      fd.append('message', content)
      fd.append('time', time)
      this.$store.dispatch('request', {
        method: 'post',
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/videos/${this.videoId}/notes`,
        data: fd
      }).then(id => {
        alert('成功')
        this.notes.push({
          id: id,
          label: '',
          time: time,
          message: content,
          time_string: timeToString(time)
        })
        this.sort_note()
        this.isTakingNote = false
      })
    },
    delete_note: function (id) {
      if (!confirm('是否確認刪除筆記內容？')) {
        return
      }
      try {
        this.$store.dispatch('request', {
          method: 'delete',
          route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/videos/${this.videoId}/notes/${id}`
        }).then(() => {
          alert('已刪除筆記')
          let index = this.notes.findIndex(n => n.id === id)
          this.notes.splice(index, 1)
        })
      } catch (err) {
        alert('失敗')
      }
    },
    edit_note: function () {
      let fd = new FormData()
      fd.append('message', this.noteContent)
      let video = document.getElementById('video')
      let time = video.currentTime
      fd.append('time', time)
      this.$store.dispatch('request', {
        method: 'post',
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/videos/${this.videoId}/notes/${this.note.id}`,
        data: fd
      }).then(() => {
        alert('成功')
        this.note.message = this.noteContent
        this.note.time = time
        this.note.time_string = timeToString(time)
        console.log(this.note)
        this.note = null
        this.isTakingNote = false
        this.sort_note()
      })
    },
    cancel_note_taking: function () {
      this.note = null
      this.isTakingNote = false
      this.noteContent = ''
    },
    startEditNote: function (note) {
      this.note = note
      this.noteContent = note.message
      this.seekVideo(note.time)
      this.isTakingNote = true
    },
    sort_note: function () {
      console.log('sort note')
      this.notes.sort((a, b) => a.time - b.time)
    },
    seekVideo: function (time) {
      let video = document.getElementById('video')
      video.pause()
      video.currentTime = time
    },
    onVideoPlaying: function (e) {
      console.log(e)
    },
    onVideoSeeked: function (e) {
      console.log(e)
    },
    onTimeUpdate: function (e) {
      if (!this.isTakingNote) return
      this.currentTime = timeToString(e.currentTarget.currentTime)
    },

    post_comment: function (e) {
      let fd = new FormData()
      fd.append('message', this.commentMessage)
      this.$store.dispatch('request', {
        method: 'post',
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/videos/${this.videoId}/comments`,
        data: fd
      }).then(comment => {
        alert('成功')
        this.comments.push(comment)
        this.commentMessage = ''
      })
    }
  },
  computed: {
    timeString: function () {
      let video = document.getElementById('video')
      let currentTime = video.currentTime
      let hour = ('00' + parseInt(currentTime / 3600)).substr(-2)
      let minute = ('00' + parseInt(currentTime % 3600 / 60)).substr(-2)
      let second = ('00' + parseInt(currentTime % 60)).substr(-2)
      return `${hour}:${minute}:${second}`
    }
  },
  mounted: function () {
    this.$store.dispatch('request', {
      route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}`
    }).then(activity => {
      console.log(activity)
      this.name = activity.name
      this.description = activity.description
    })
    this.$store.dispatch('request', {
      route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/videos`
    }).then(video => {
      console.log(video)
      this.videoId = video.id
      console.log(video.html_path)
      fetch(video.html_path).then(r => {
        this.url = r.url
      }).catch(() => {
        this.url = video.html_path
      })
      this.$store.dispatch('request', {
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/videos/${this.videoId}/notes`
      }).then(notes => {
        console.log(notes)
        this.notes = notes
      })
      this.$store.dispatch('request', {
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/videos/${this.videoId}/comments`
      }).then(comments => {
        console.log(comments)
        this.comments = comments
      })
    })
  }
}
</script>
